const forms = document.querySelectorAll('form');

forms.forEach((form) => {
  const compositeFields = form.querySelectorAll('.field');

  compositeFields.forEach((field) => {
    const input = field.querySelector('input:not([type="radio"]):not([type="checkbox"]), textarea');

    if (input) {
      input.addEventListener('focus', () => {
        field.classList.add('is-active');
      });

      input.addEventListener('blur', () => {
        const isValid = input.checkValidity();

        if (isValid) {
          input.classList.remove('is-invalid');
        } else {
          input.classList.add('is-invalid');
        }
      });
    }
  });

  if (form.id === 'JobApplicationForm_ApplicationForm') {
    form.addEventListener('submit', (e) => {
      const phoneNumber = form.querySelector('input[name="PhoneNumber"]');
      const email = form.querySelector('input[name="Email"]');

      const errorMessagePhone = document.createElement('span');
      errorMessagePhone.classList.add('message', 'error');
      errorMessagePhone.innerText = 'Telefoon of email is verplicht';

      const errorMessageEmail = document.createElement('span');
      errorMessageEmail.classList.add('message', 'error');
      errorMessageEmail.innerText = 'Telefoon of email is verplicht';

      if (phoneNumber.value === '' && email.value === '') {
        phoneNumber.classList.add('is-invalid');
        email.classList.add('is-invalid');

        if (!phoneNumber.parentNode.querySelector('.message')) {
          phoneNumber.parentNode.appendChild(errorMessagePhone);
        }

        if (!email.parentNode.querySelector('.message')) {
          email.parentNode.appendChild(errorMessageEmail);
        }

        e.preventDefault();
      } else {
        e.currentTarget.submit();
      }
    });
  }
});
